/**
 * Delay in milliseconds before the progress bar is shown.
 */
export const RouterProgressDelay = 240;
